import BaseObject from '../../../../base/base_object';
import _ from "../../../../utils/underscore";
import Device from "../../../../utils/device/device";
import {ONE_TRUST} from "./one_trust_hybrid_consts";
import {KEY_NAME} from "../../native/native_const";
import {SYSTEM_EVENTS} from "../../../../events/events";




/**
 *
 *
 */
class OneTrust extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'OneTrust';
    _HybridService = null;
    _bEnable = false;
    _cdn = '';
    _domainId= '';


    init(params) {

        super.init(params);

        if(_.isNullOrUndefined(params)){
            return;
        }
        if (Device.hybrid.isHybrid) {
            this._bEnable = params.enable;
            this._cdn = params.cdn;


            if (Device.os.isIOS) {
                params = params.ios;
            } else if (Device.os.isAndroid) {
                params = params.android;
            }
            this._domainId = params.domainId;
        }
    }


    initFeatures(hybridSrv) {

        this._HybridService = hybridSrv;

        if (Device.hybrid.isHybrid) {
            this._HybridService.onSystemEvent(SYSTEM_EVENTS.ON_INIT_COMPLETE, () => {
                this.initOneTrust();
            });
        }
        return this;
    }

    initOneTrust(){

            const enable = this._bEnable.toString();
            const display = 'false';//display each 6 months
            const cdn = this._cdn;
            const domainId = this._domainId;
            const lang = this._HybridService.serviceFactory.languageService().getISO2();
            const country= '';//'US';
            const region = '';//'CA';

            const dt = {[ONE_TRUST.ENABLE]: enable,[ONE_TRUST.DISPLAY]: display ,[ONE_TRUST.CDN]: cdn,[ONE_TRUST.DOMAIN_ID]: domainId, [ONE_TRUST.LANG]: lang,
                [ONE_TRUST.COUNTRY]: country, [ONE_TRUST.REGION]: region};

            this._HybridService.initOneTrust(dt).then(data => {
                data = _.safeJSONandDecode(data);
                const keyData = data[KEY_NAME.DATA];
                if(undefined !== keyData) {
                    const display = keyData[KEY_NAME.ONE_TRUST_DISPLAY];
                    const status = keyData[KEY_NAME.ONE_TRUST_STATUS];
                    const butClick = keyData[KEY_NAME.ONE_TRUST_BUT_CLICK];

                    if('true' === display) {
                        this._sendElasticEvent(butClick,status);
                    }
                }
            });
        }

    _sendElasticEvent(label, value){

        const dataToSend  = {
            CGPEventCategory: ONE_TRUST.DMA_BANNER,
            CGPEventAction: ONE_TRUST.USER_RESPONSE,
            CGPEventLabel: label,
            CGPEventValue: value
        };

        this._HybridService.serviceFactory.structuredLoggingService().getLogger(dataToSend).info();
    }
}

export default OneTrust;
